/**
 * The payment-callback page polls its own loader in place via
 * `useRevalidator()` (see the page's own docs for the polling design). React
 * Router revalidation re-runs every active loader on each tick, including the
 * root loader, which makes two live external calls (distributor resolution +
 * marketing providers). Root's data (tenant/i18n/theme) is stable for the
 * page's lifetime, so we can safely skip root on those poll ticks.
 *
 * Scoped deliberately: only same-path revalidations that land on
 * `…/payment/callback` are skipped. A real navigation onto or off of the
 * callback page (different pathname) still revalidates root normally, as
 * does same-path revalidation on every other route.
 */
export function shouldSkipRootRevalidation(
  currentPathname: string,
  nextPathname: string
): boolean {
  return (
    currentPathname === nextPathname &&
    nextPathname.endsWith('/payment/callback')
  );
}
